<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer013">
<p class="chapter-title-only" id="_idParaDest-3"><span class="bold CharOverride-6"><a id="_idTextAnchor002"></a>Prologue</span></p>
<p class="text-flush-left">When my friend Richard was diagnosed at the age of 56—the age I am now—with glioblastoma, a rare and inoperable brain cancer, I decided to chronicle his journey, writing a long letter to him, capturing our conversations and reflecting on moments together that his wife and daughters hadn’t necessarily shared, with the notion that I would give the piece to them as one version of his story.</p>
<p class="text-indented">What astonished me about his steady decline was Richard’s choice to live his certain death with playfulness, graciousness and wit. If anyone had the right to wallow in self-pity and darkest melancholy, he did. But, remarkably, Richard chose the light: we all have a choice. And, although his luck in the cancer lottery was unacceptably bad, he was determined to show his family and friends that every waking moment is precious. Every day above ground is a good one.</p>
<p class="text-indented">At Richard’s core he was essentially an entertainer. In spite of increased confusion about his daily reality, as the cancer spread at a gallop across his brain, he was able to retrieve vast swaths of information from his long-term memory and we nattered about literature (since he taught English and Drama for 25 years) and harvested musical show tunes to fit the moments we were inhabiting that were as much a part of both of us as the rhythmic excerpts from Shakespeare’s canon or Oscar Wilde’s clever aphorisms.</p>
<p class="text-indented-space-after">We are all worthy of our final moment and its telling, and it matters how we play it in the end.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HowMidsummerNight-3.vue?bcae660c